import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {
    QualitativeEvaluationModule
} from '../../../calibration/components/user-overview/qualitative-evaluation/qualitative-evaluation.module';
import {PipesModule} from '../../pipes/pipes.module';
import {AiManagementEvaluationComponent} from './ai-management-evaluation.component';
import {AiGeneralSummaryModalModule} from '../../modals/ai-general-summary-modal/ai-general-summary-modal.module';
import {AiManagementEvaluationService} from './ai-management-evaluation.service';
import { AiManagementEvaluationUserListComponent } from './ai-management-evaluation-user-list/ai-management-evaluation-user-list.component';

@NgModule({
    declarations: [AiManagementEvaluationComponent, AiManagementEvaluationUserListComponent],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        AiGeneralSummaryModalModule,
        QualitativeEvaluationModule
    ],
    exports: [AiManagementEvaluationComponent, AiManagementEvaluationUserListComponent],
    providers: [AiManagementEvaluationService]
})
export class AiManagementEvaluationModule {
}
